/* Copyright (c) 2020-present CloudIO Inc */

import { DBRow, IoHowTos } from '@cloudio-saas/datasource-types';
import { Box, IconButton } from '@mui/material';
import Icon from 'icons/Icon';
import { useOrgNameAndLogo } from 'layout/Header/OrgLogo';
import WaveDots from 'utils/WaveDots';

export default function HowToHeader({
  appUid,
  howTo,
}: {
  appUid: string;
  howTo?: DBRow<IoHowTos>;
}) {
  const [{ logoImage, orgName, pending }] = useOrgNameAndLogo();

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bgcolor: 'background.paper',
        zIndex: 20,
        p: '16px 24px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
      }}
    >
      <Box
        sx={{ height: '3rem', cursor: 'pointer' }}
        onClick={() => {
          window.location.href = `#/how-to/${appUid}`;
        }}
      >
        {pending ? (
          <WaveDots active />
        ) : (
          <img
            style={{ maxHeight: '100%', maxWidth: '100%' }}
            src={logoImage}
            alt={orgName}
          />
        )}
      </Box>
      {howTo ? (
        <IconButton
          href={`#/${appUid}/how-to/${howTo.howToUid}`}
          target="_blank"
          color="primary"
          data-tip="Edit"
        >
          <Icon iconName="pencil" color="primary" />
        </IconButton>
      ) : null}
    </Box>
  );
}
